
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"9","height":"14","viewBox":"0 0 9 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.5 0C2.01875 0 0 2.09352 0 4.66668C0 5.43914 0.186231 6.20504 0.540263 6.88436L4.25392 13.8496C4.30335 13.9425 4.39756 14 4.5 14C4.60244 14 4.69665 13.9425 4.74608 13.8496L8.46111 6.88207C8.81377 6.20504 9 5.43911 9 4.66665C9 2.09352 6.98125 0 4.5 0ZM4.5 7C3.25937 7 2.25001 5.95325 2.25001 4.66668C2.25001 3.3801 3.25937 2.33335 4.5 2.33335C5.74063 2.33335 6.74999 3.3801 6.74999 4.66668C6.74999 5.95325 5.74063 7 4.5 7Z","fill":"#90B49A"}})])
          )
        }
      }
    